import { IconButton } from '@mui/material'
import KeyboardArrowDown from '@mui/icons-material/KeyboardArrowDown'
import KeyboardArrowUp from '@mui/icons-material/KeyboardArrowUp'
import { useEffect } from 'react'
import { useDataTableContext } from './DataTableContext'

function TableCollapseButton({
    groupRowkey,
    openCollapse,
    subRowLevel,
    isVisible,
}: {
    groupRowkey: string
    openCollapse: boolean
    subRowLevel?: number
    isVisible?: boolean
}) {
    const {
        onToggleCollapse,
        forceOpenCollapse,
        setOpenForceCollapse,
    } = useDataTableContext()

    useEffect(() => {
        if (forceOpenCollapse) {
            onToggleCollapse(groupRowkey)
            setOpenForceCollapse(false)
        }
    }, [forceOpenCollapse, onToggleCollapse, groupRowkey, setOpenForceCollapse])

    return (
        <IconButton
            aria-label="expand row"
            size="small"
            onClick={(e) => {
                e.stopPropagation()
                onToggleCollapse(groupRowkey)
            }}
        >
            {subRowLevel && subRowLevel > 0 && (
                <span style={{ width: 10 * (subRowLevel ?? 0) }}>&nbsp;</span>
            )}

            {isVisible === false ? (
                <KeyboardArrowUp sx={{ visibility: 'hidden' }} />
            ) : openCollapse ? (
                <KeyboardArrowUp />
            ) : (
                <KeyboardArrowDown />
            )}
        </IconButton>
    )
}

export default TableCollapseButton
